<template>
  <div>
    <v-container>
      <v-row
        class="mt-4"
        justify="center" align-content="center"      
      >
        <amplify-authenticator v-if="!this.$store.state.user" id="new_style"></amplify-authenticator>
        <amplify-sign-out v-if="this.$store.state.user"></amplify-sign-out>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "LoginView"
};
</script>

<style>

#new_style{
  width: 95%;
  height: 80%;
  font-size: 8px;
  text-align: center;
}
</style>